// extracted by mini-css-extract-plugin
export default {"wrapper":"customerSettings_wrapper__RBSLd"};